import React, { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { tableHead, tableCell } from "./waShared";

// ─── Recent messages log (inbound + outbound) ────────────────────────
function LogPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/whatsapp/messages?limit=80");
      setItems(r.data?.items || []);
    } catch (_e) { setItems([]); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="card" style={{ padding: 20, textAlign: "center" }}>⏳ جارٍ التحميل...</div>;

  if (items.length === 0) {
    return <div className="card" style={{ padding: 18, textAlign: "center", color: "var(--muted)", fontSize: 13 }}>
      لا توجد رسائل في السجل بعد. ابدأ بإرسال رسالة اختبار أو حملة من التبويبات أعلاه.
    </div>;
  }

  return (
    <div className="card" style={{ padding: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <div style={{ fontSize: 12.5, fontWeight: 700, color: "var(--brown-deep)" }}>📋 آخر {items.length} رسالة</div>
        <button type="button" onClick={load} className="btn btn-soft" style={{ fontSize: 11 }} data-testid="wa-log-refresh">🔄 تحديث</button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", fontSize: 11.5, borderCollapse: "collapse" }}>
          <thead style={{ background: "var(--beige)" }}>
            <tr>
              <th style={tableHead}>الاتجاه</th>
              <th style={tableHead}>الرقم</th>
              <th style={tableHead}>النوع</th>
              <th style={tableHead}>الحالة</th>
              <th style={tableHead}>القالب/المحتوى</th>
              <th style={tableHead}>المُرسل</th>
              <th style={tableHead}>حجم الدفعة</th>
            </tr>
          </thead>
          <tbody>
            {items.map((m, i) => (
              <tr key={m.whatsapp_message_id || i} style={{ borderTop: "1px solid var(--border)" }}>
                <td style={tableCell}>
                  {m.direction === "inbound"
                    ? <span style={{ color: "#0EA5E9", fontWeight: 700 }}>📥 وارد</span>
                    : <span style={{ color: "#7C3AED", fontWeight: 700 }}>📤 صادر</span>}
                </td>
                <td style={tableCell}>{m.to || m.from || "—"}</td>
                <td style={tableCell}>{m.type || "—"}</td>
                <td style={{ ...tableCell, fontWeight: 700, color: statusColor(m.status) }}>{m.status || "—"}</td>
                <td style={{ ...tableCell, maxWidth: 280, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {m.template ? `📨 ${m.template}` : (m.body || "—")}
                </td>
                <td style={tableCell} data-testid={`wa-log-sender-${i}`}>{m.sent_by || "—"}</td>
                <td style={tableCell} data-testid={`wa-log-batchsize-${i}`}>{m.batch_size || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function statusColor(s) {
  if (s === "sent" || s === "delivered") return "#16a34a";
  if (s === "read") return "#0EA5E9";
  if (s === "received") return "#0EA5E9";
  if (s === "failed") return "#dc2626";
  return "var(--muted)";
}

export default LogPanel;
